import request from '@/utils/request'

// 新增用户状态
export function userStatusAdd(data) {
  return request({
    url: '/user-status',
    method: 'post',
    data
  })
}

// 根据用户ID和题库ID删除用户状态
export function deleteStatusByUserAndRepo(userId, repoId) {
  return request({
    url: `/user-status/user/${userId}/repo/${repoId}`,
    method: 'delete'
  })
}

// 根据 ID 删除用户状态
export function userStatusDel(id) {
  return request({
    url: `/user-status/${id}`,
    method: 'delete'
  })
}

// 批量删除用户状态
export function userStatusBatchDel(ids) {
  return request({
    url: '/user-status/batch',
    method: 'delete',
    data: ids
  })
}

// 更新用户状态
export function userStatusUpdate(data) {
  return request({
    url: '/user-status',
    method: 'put',
    data
  })
}

// 根据 ID 查询用户状态
export function userStatusDetail(id) {
  return request({
    url: `/user-status/${id}`,
    method: 'get'
  })
}

// 分页查询用户状态
export function userStatusPage(params) {
  return request({
    url: '/user-status/page',
    method: 'get',
    params
  })
}

// 根据用户 ID 查询用户状态列表，支持附带 repoId 参数
export function userStatusByUser(userId, repoId) {
  return request({
    url: `/user-status/user/${userId}`,
    method: 'get',
    params: repoId != null && repoId !== '' ? { repoId } : {}
  })
}

// 查询所有用户状态
export function userStatusAll() {
  return request({
    url: '/user-status/all',
    method: 'get'
  })
}

// 查询连对挑战的最大 count 值（可选按用户过滤）
export function getMaxChallengeCount(userId) {
  return request({
    url: '/user-status/maxChallengeCount',
    method: 'get',
    params: userId != null ? { userId } : {}
  })
}

// 统计每日一题坚持天数（必须提供 userId）
export function getDailyStreakDays(userId) {
  return request({
    url: '/user-status/dailyStreakDays',
    method: 'get',
    params: { userId }
  })
}
